import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { GuestOnlyGuard } from '@/components/auth-guard';
import { RegisterForm } from '@/features/auth/components/register-form';
import { AuthCard } from '@/features/auth/views';

const STRONG_LINK_STYLE = {
  color: 'var(--vq-ink)',
  textDecoration: 'none',
  fontWeight: 500,
} as const;

function RegisterRoute(): ReactNode {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [allowVerificationStep, setAllowVerificationStep] = useState(false);

  return (
    <GuestOnlyGuard allowAuthenticated={allowVerificationStep}>
      <AuthCard
        title={t('register.title')}
        subtitle={t('register.subtitle')}
        footer={
          <span>
            {t('register.haveAccount')}{' '}
            <Link to="/login" style={STRONG_LINK_STYLE} className="hover:underline">
              {t('register.signIn')}
            </Link>
          </span>
        }
      >
        <RegisterForm
          onRegistered={() => {
            setAllowVerificationStep(true);
          }}
          onSuccess={() => {
            void navigate({ to: '/dashboard' });
          }}
        />
      </AuthCard>
    </GuestOnlyGuard>
  );
}

export const Route = createFileRoute('/register')({
  component: RegisterRoute,
});
